import React, { useState } from 'react';
import Card from '../components/Card';
import { Button } from 'react-bootstrap';
import FormQuestions from '../../FormQuestions';
import FormQuestionModal from '../../FormQuestionModal';
import axiosInstance from '../../../Store/helper/axiosInstance';
import { toast } from 'react-toastify';
import { reactHtmlParser } from '../../../common/common';

const SupportCta = ({
  ctaId,
  ctaType,
  className = '',
  type = '',
  title = '',
  description = '',
  buttonText = '',
  isForm = false,
  buttonAction = false,
  form = [],
  clickCallback
}) => {
  const [userInput, setUserInput] = useState({});
  const [isd, setIsd] = useState('+91');
  const [show, setShow] = useState(false);
  const onHide = () => setShow(false);
  const handleCheckboxInput = (e) => {
    console.log('user has changed checkbox input:', e.target.value);
    const { name, value } = e.target;
    setUserInput((prev) => {
      let prevValue = prev[name];
      let prevArr = prevValue?.split(',') ?? [];
      let newArr = [...prevArr, value];
      return {
        ...prev,
        [name]: newArr.join()
      };
    });
  };
  const handleUserTextInput = (e) => {
    console.log('user has changed input:', e.target.value);
    const { name, value } = e.target;
    setUserInput((prev) => ({
      ...prev,
      [name]: value
    }));
  };
  const postForm = async (userInput) => {
    console.log('user has clicked submit button');
    if (form.some((_q) => _q.is_mandatory == 1 && !userInput[_q.field_name])) {
      toast.error('Please fill all mandatory fields');
      return;
    }
    let response = await axiosInstance.post('cta/cta_submitted_forms', {
      cta_id: ctaId,
      cta_type: ctaType,
      submitted_form_json: userInput
    });
    console.log('response:', response);
    if (response.status == 200) {
      toast.success('Your Response submitted successfully');
      onHide();
    }
  };
  const onClickButton = () => {
    clickCallback && clickCallback(ctaId);
    if (buttonAction == 'post') {
      postForm(userInput);
    } else if (buttonAction == 'form') {
      setShow(true);
    }
  };
  return (
    <>
      <Card className={`clr_v3_card--supportCta ${className ?? ''}`} type={type}>
        <Card.Body>
          <div
            className={`d-flex gap-4 ${
              type === 'small' ? 'flex-row align-items-center' : 'flex-column'
            }`}
          >
            {/* flex-row */}

            <div className="d-flex flex-column">
              <Card.Title className="hover-opacity mt-0">{title}</Card.Title>
              {isForm ? (
                <form>
                  <div className="w-100 centerModalFrm">
                    {form?.length > 0
                      ? form?.map((_qus, _idx) => (
                          <div
                            className="col-12 shareLoginV2FormRow mt-4 position-relative p-0"
                            key={_idx + 1}
                          >
                            <FormQuestions
                              handleCheckboxInput={handleCheckboxInput}
                              handleUserTextInput={handleUserTextInput}
                              index={_idx}
                              question={_qus}
                              setIsd={setIsd}
                              userInput={userInput}
                              key={'samplecta' + _idx + 1}
                            />
                          </div>
                        ))
                      : null}
                  </div>
                </form>
              ) : description ? (
                <Card.Description showFullText>{reactHtmlParser(description)}</Card.Description>
              ) : null}

              <div className="mt-4 d-flex gap-3 flex-wrap ">
                {buttonText && (
                  <Button
                    size="sm"
                    className={`text-nowrap fs-4 gap-2 d-flex justify-content-center align-items-center ms-auto`}
                    onClick={onClickButton}
                  >
                    {buttonText}
                    <i className="flaticon-next"></i>
                  </Button>
                )}
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
      {form?.length > 0 && buttonAction === 'form' && (
        <FormQuestionModal show={show} onHide={onHide} submitClick={postForm} form={form} />
      )}
    </>
  );
};

export default SupportCta;
